import { LocaleContext } from '@/providers/locale-provider'
import { Answer, Question } from '@/types/questions'
import { ChoiceList, ChoiceListTypes, FormRadioField } from '@lib-components'
import { ChangeEvent, use, ReactElement } from 'react'
import { Control, FieldValues, Controller } from 'react-hook-form'

type RadioQuestionProps = {
    question: Question
    name: string
    control: Control<FieldValues, unknown>
    inline: boolean
}

const RadioQuestion = ({ question, name, control, inline }: RadioQuestionProps): ReactElement => {
    const localeContext = use(LocaleContext)

    return (
        <>
            {localeContext.getLocaleText(question.questionContent.text)}
            <ChoiceList
                type={inline ? ChoiceListTypes.INLINE : ChoiceListTypes.DEFAULT}
                className={`${inline ? 'items-center gap-2' : 'w-full'}`}
            >
                {question.questionContent.answers.map((answer: Answer) => (
                    <Controller
                        key={answer.id}
                        control={control}
                        name={name}
                        shouldUnregister
                        render={({ field: { onChange } }) => (
                            <FormRadioField
                                name={name}
                                value={answer.id}
                                label={localeContext.getLocaleText(answer.text)}
                                onChange={(internalValue: ChangeEvent<HTMLInputElement>) => {
                                    onChange({ target: { value: internalValue.target?.value } })
                                }}
                                boxed={inline}
                            />
                        )}
                    />
                ))}
            </ChoiceList>
        </>
    )
}

export default RadioQuestion
